const INDEX_ITEMS = [
  { title: '古装仙侠剧场', count: '856部', icon: 'ri-sword-line', color: 'bg-accent-100 text-accent-700' },
  { title: '都市情感剧场', count: '1,203部', icon: 'ri-heart-line', color: 'bg-primary-100 text-primary-700' },
  { title: '悬疑推理专场', count: '672部', icon: 'ri-search-eye-line', color: 'bg-secondary-100 text-secondary-700' },
  { title: '科幻奇幻世界', count: '489部', icon: 'ri-rocket-line', color: 'bg-accent-100 text-accent-700' },
  { title: '喜剧搞笑合集', count: '934部', icon: 'ri-emotion-laugh-line', color: 'bg-primary-100 text-primary-700' },
  { title: '动作冒险大片', count: '1,056部', icon: 'ri-fire-line', color: 'bg-secondary-100 text-secondary-700' },
  { title: '日韩海外剧场', count: '2,145部', icon: 'ri-global-line', color: 'bg-accent-100 text-accent-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            专题合集
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            热门影视专题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            按类型与题材精选分类，快速找到你想看的影视内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {INDEX_ITEMS.map((item, i) => (
            <a
              key={i}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className={`group flex items-center gap-4 p-5 rounded-2xl border border-background-200/60 bg-background-50 hover:border-primary-300 transition-all cursor-pointer ${i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''}`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl shrink-0 ${item.color} ${i === 0 ? 'w-16 h-16' : ''}`}>
                <i className={`${item.icon} ${i === 0 ? 'text-2xl' : 'text-xl'}`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors ${i === 0 ? 'text-xl' : 'text-base'}`}>
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">{item.count} 部作品</p>
              </div>
              <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-500 transition-colors shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}